import React, {Component} from "react";
import "./PageSearch.css";
import {requestApiJson} from "../utils/Utils";
import {getSearchParams} from "../utils/getSearchParams";
import config from "../config";
import {GridView} from "../components/GridView";
import {ListView} from "../components/ListView";
import {getTokenValue} from "../utils/authToken";
import {MainContent, MainHeader} from "../components/Layout";

export class PageSearch extends Component {

    static noItems() {
        return {
            items: [],
            totalSize: 0
        };
    }

    constructor(props) {
        super(props);

        this.state = {
            searchQuery: this.fetchSearchQuery(),
            searchModified: false,
            audios: PageSearch.noItems(),
            images: PageSearch.noItems(),
            videos: PageSearch.noItems(),
            documents: PageSearch.noItems()
        };
    }

    fetchSearchQuery = () => {
        let params = getSearchParams();
        return params.q ? decodeURIComponent(params.q) : "";
    };

    componentDidMount() {
        if (this.state.searchQuery) {
            this.loadAudios();
            this.loadImages();
            this.loadVideos();
            this.loadDocuments();
        }

        window.addEventListener("popstate", this.onHistoryChange);
    }

    getResourceUrl = (item) => {
        return "/view/" + item.id;
    };

    loadAudios = () => {
        this.setState(
            s => {
                s.audios.loading = true;
                s.searchModified = false;
                return s;
            },
            () => {
                const offset = this.state.audios.items.length;

                let url = `/res/search?contentType=audio&offset=${offset}`;
                url += `&query=${encodeURIComponent(this.state.searchQuery)}`;

                requestApiJson(url, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
                    .then(response => {
                        this.setState(state => {
                            if (state.audios.items.length > offset) {
                                console.log("Data seems already loaded; slicing items");
                                state.audios.items = state.audios.items.slice(0, offset);
                            }

                            state.audios.totalSize = response.totalSize;
                            state.audios.items = [...state.audios.items, ...response.items];
                            state.audios.loading = false;

                            window.history.replaceState(this.state, "", "/search?q=" + this.state.searchQuery);

                            return state;
                        });
                    });
            });
    };

    loadImages = () => {
        this.setState(
            s => {
                s.images.loading = true;
                s.searchModified = false;
                return s;
            },
            () => {
                const offset = this.state.images.items.length;

                let url = `/res/search?contentType=image&offset=${offset}`;
                url += `&query=${encodeURIComponent(this.state.searchQuery)}`;

                requestApiJson(url, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
                    .then(response => {
                        this.setState(state => {
                            if (state.images.items.length > offset) {
                                console.log("Data seems already loaded; slicing items");
                                state.images.items = state.images.items.slice(0, offset);
                            }

                            state.images.totalSize = response.totalSize;
                            state.images.items = [...state.images.items, ...response.items];
                            state.images.loading = false;

                            window.history.replaceState(this.state, "", "/search?q=" + this.state.searchQuery);

                            return state;
                        });
                    });
            });
    };

    loadVideos = () => {
        this.setState(
            s => {
                s.videos.loading = true;
                s.searchModified = false;
                return s;
            },
            () => {
                const offset = this.state.videos.items.length;

                let url = `/res/search?contentType=video&offset=${offset}`;
                url += `&query=${encodeURIComponent(this.state.searchQuery)}`;

                requestApiJson(url, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
                    .then(response => {
                        this.setState(state => {
                            if (state.videos.items.length > offset) {
                                console.log("Data seems already loaded; slicing items");
                                state.videos.items = state.videos.items.slice(0, offset);
                            }

                            state.videos.totalSize = response.totalSize;
                            state.videos.items = [...state.videos.items, ...response.items];
                            state.videos.loading = false;

                            window.history.replaceState(this.state, "", "/search?q=" + this.state.searchQuery);

                            return state;
                        });
                    });
            });
    };

    loadDocuments = () => {
        this.setState(
            s => {
                s.documents.loading = true;
                s.searchModified = false;
                return s;
            },
            () => {
                const offset = this.state.documents.items.length;

                let url = `/res/search?contentType=other&offset=${offset}`;
                url += `&query=${encodeURIComponent(this.state.searchQuery)}`;

                requestApiJson(url, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
                    .then(response => {
                        this.setState(state => {
                            if (state.documents.items.length > offset) {
                                console.log("Data seems already loaded; slicing items");
                                state.documents.items = state.documents.items.slice(0, offset);
                            }

                            state.documents.totalSize = response.totalSize;
                            state.documents.items = [...state.documents.items, ...response.items];
                            state.documents.loading = false;

                            window.history.replaceState(this.state, "", "/search?q=" + this.state.searchQuery);

                            return state;
                        });
                    });
            });
    };

    onSearchChange = (e) => {
        this.setState({
            searchQuery: e.target.value,
            searchModified: true
        });
    };

    onSearchKeyUp = (e) => {
        if (e.keyCode === 13) {
            // this.props.history.push("/search?q=" + this.state.searchQuery);
            window.history.pushState(this.state, "", "/search?q=" + this.state.searchQuery);

            this.setState(state => {
                    state.folders = PageSearch.noItems();
                    state.audios = PageSearch.noItems();
                    state.images = PageSearch.noItems();
                    state.videos = PageSearch.noItems();
                    state.documents = PageSearch.noItems();

                    return state;
                },
                () => {
                    if (this.state.searchQuery) {
                        this.loadAudios(0);
                        this.loadImages(0);
                        this.loadVideos(0);
                        this.loadDocuments(0);
                    }
                }
            );
        }
    };

    onHistoryChange = (e) => {
        this.setState(e.state);
    };

    render() {
        return [<MainHeader>
            {<input className="block-search" type="search" value={this.state.searchQuery} placeholder="Search..."
                    onChange={this.onSearchChange}
                    onKeyUp={this.onSearchKeyUp}
                    autoFocus/>}
        </MainHeader>,
            <MainContent>
                {this.renderResults()}
            </MainContent>];
    }

    renderResults = () => {
        if (this.state.searchQuery && !this.state.searchModified
            && !this.state.audios.loading && this.state.audios.totalSize === 0
            && !this.state.images.loading && this.state.images.totalSize === 0
            && !this.state.videos.loading && this.state.videos.totalSize === 0
            && !this.state.documents.loading && this.state.documents.totalSize === 0) {
            return <div className="muted pt-3 pl-3 pr-3 pb-3">Nothing found</div>;
        }

        return [
            <ListView title="Audios"
                      items={this.state.audios.items}
                      totalSize={this.state.audios.totalSize}
                      loading={this.state.audios.loading}
                      icon={() => "img/ic-file.png"}
                      itemTitle={item => item.fileName}
                      itemSubTitle={item => item.folder}
                      onClickUrl={this.getResourceUrl}
                      onLoadMore={this.loadAudios}
            />,
            <GridView title="Images"
                      items={this.state.images.items}
                      totalSize={this.state.images.totalSize}
                      loading={this.state.images.loading}
                      onClickUrl={this.getResourceUrl}
                      onLoadMore={this.loadImages}
            />,
            <GridView title="Videos"
                      items={this.state.videos.items}
                      totalSize={this.state.videos.totalSize}
                      loading={this.state.videos.loading}
                      onClickUrl={this.getResourceUrl}
                      onLoadMore={this.loadVideos}
            />,
            <ListView title="Documents"
                      items={this.state.documents.items}
                      totalSize={this.state.documents.totalSize}
                      loading={this.state.documents.loading}
                      icon={() => "img/ic-file.png"}
                      itemTitle={item => item.fileName}
                      itemSubTitle={item => item.folder}
                      onClickUrl={this.getResourceUrl}
                      onLoadMore={this.loadDocuments}
            />
        ];
    };
}
